import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS} from '@/queryClient'
import {httpUploadBugReportAttachment} from '../services/bugReporter.http'
import {BugReportAttachmentRef} from '../types'

type BugReporterErrorResponse = {code?: string; message?: string}

/**
 * Uploads one file to the backend proxy. Callers read
 * `error.response?.data?.message` on failure to surface the backend's own
 * (authoritative) validation message — no shared `errorHandler`, since that maps
 * a fixed code table and would discard the backend's per-file message.
 */
export const useUploadBugReportAttachment = () =>
    useMutation<BugReportAttachmentRef, AxiosError<BugReporterErrorResponse>, FormData>({
        mutationKey: [MUTATION_KEYS.UPLOAD_BUG_REPORT_ATTACHMENT],
        mutationFn: formData => httpUploadBugReportAttachment(formData)
    })
